import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import MatrixCell from "./MatrixCell";
import MatrixControls from "./controls/MatrixControls";
import IntervalSetSaveButton from "./controls/widgets/IntervalSetSaveButton";
import { MatrixHeadingControlsRowProps } from "./MatrixCommSetsControlsRow";

export const MatrixHeadingControlsRowStyled = styled(TableRow)(({ theme }) => ({
  div: {
    backgroundColor: "white",
    padding: "0px",
  },
}));


const MatrixTopControlsRow = (props: MatrixHeadingControlsRowProps) => {
  const [controlsBorderStyle, setControlsBorderStyle] = useState<any>({
    height:"5px",
    paddingLeft: "5px",
    paddingRight: "5px",
    paddingBottom: "0px",
    paddingTop: "5px",
    overflowX: "auto",
    whiteSpace: "nowrap",
    width:"100%"
  });

  return (
    <MatrixHeadingControlsRowStyled>
      <MatrixCell
        colSpan={props.associatedIntervals.length + 1}
        style={controlsBorderStyle}
      >
      </MatrixCell>
    </MatrixHeadingControlsRowStyled>
  );
};

export default MatrixTopControlsRow;
